export const getCloudinaryUrl = (imageDomain, imagePath, height, width, format = 'jpg') => {
  const parameters = `c_fill,w_${width},h_${height},f_${format},q_auto:eco`;
  return `${imageDomain}/image/upload/${parameters}${imagePath}`;
};

export const getCloudinaryLogoUrl = (imageDomain, imagePath, height, format = 'jpg') => {
  const parameters = `c_scale,h_${height},f_${format}`;
  return `${imageDomain}/image/upload/${parameters}${imagePath}`;
};

export const getCloudinarySources = (mediaString, imageDomain, imagePath, height, width) => {
  return [
    {
      media: mediaString,
      srcSet: getCloudinaryUrl(imageDomain, imagePath, height, width, 'avif'),
      type: 'image/avif',
    },
    {
      media: mediaString,
      srcSet: getCloudinaryUrl(imageDomain, imagePath, height, width, 'jp2'),
      type: 'image/jp2',
    },
    {
      media: mediaString,
      srcSet: getCloudinaryUrl(imageDomain, imagePath, height, width, 'webp'),
      type: 'image/webp',
    },
    {
      media: mediaString,
      srcSet: getCloudinaryUrl(imageDomain, imagePath, height, width),
      type: 'image/jpeg',
    },
  ];
};

const getCloudinaryLogoSource = (imageDomain, imagePath, height, format, media) => {
  return {
    srcSet: `
      ${getCloudinaryLogoUrl(imageDomain, imagePath, height * 2, format)} 2x,
      ${getCloudinaryLogoUrl(imageDomain, imagePath, height, format)}
    `,
    type: `image/${format}`,
    media,
  };
};

export const getCloudinaryLogoSources = (imageDomain, imagePath) => {
  return [
    getCloudinaryLogoSource(imageDomain, imagePath, 35, 'webp', '(min-width: 768px)'),
    getCloudinaryLogoSource(imageDomain, imagePath, 35, 'jpg', '(min-width: 768px)'),
    getCloudinaryLogoSource(imageDomain, imagePath, 25, 'webp', null),
    getCloudinaryLogoSource(imageDomain, imagePath, 25, 'jpg', null),
  ];
};